var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"height":"40px","icon":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_c('v-icon',[_vm._v("mdi-pencil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }